import { HomePage } from "../components/homepage/homepage";

export default function LandingPage(){
    return <HomePage />;
}